<template>
  <section class="about-me" id="about-me">
        <div class="container">
            <div class="row p-5">
                <div class="col-12 col-lg-6 text-center d-flex flex-column  align-items-center">
                    <h1 class="mt-5 mb-5 display-1">Sobre mí</h1>

                    <div id="contenedor" onmousemove="moverImagen(event)" class="">
                        <div id="fondo"></div>
                        <div id="imagen"></div>
                    </div>      

                </div>
                <div class="mt-5 col-12 col-lg-6 d-flex text-center align-items-center parra-about-me">
                    <p class="parraf-spanish">
                        Soy <strong>Andrés Molina</strong>, desarrollador de software con más de <strong>tres años de experiencia</strong> en el diseño, desarrollo e implementación de soluciones tecnológicas que generan un impacto real en las organizaciones. He liderado proyectos completos, desde la creación de <strong>APIs</strong> hasta el desarrollo de interfaces web intuitivas, asegurando siempre calidad, eficiencia y escalabilidad.
                        <br><br>
                        Mi stack principal incluye <strong>Golang, Vue.js, JavaScript y PostgreSQL</strong>, además de experiencia con <strong>Django (Python)</strong> para el desarrollo de APIs REST. Manejo despliegues en <strong>Docker, Nginx y Linux</strong>, y tengo conocimientos en <strong>AWS</strong> y administración de bases de datos. También he trabajado bajo metodologías <strong>Agile/Scrum</strong>, lo que me ha permitido colaborar efectivamente en equipos multidisciplinarios.
                        <br><br>
                        Me considero una persona <strong>proactiva, creativa y orientada a resultados</strong>, con pasión por resolver problemas y optimizar procesos. Actualmente curso la carrera de <strong>Ingeniería en Sistemas</strong>, lo que complementa mi experiencia práctica con una sólida formación académica.
                        <br><br>
                        Mi enfoque no es solo escribir código, sino entender los problemas reales y transformarlos en <strong>soluciones de valor</strong> que impulsen la innovación y el crecimiento.
                    </p>
                </div>
                
            </div>
            
        </div>
</section>
</template>

<script>
export default {

}
</script>

<style>
    .parraf-spanish {
        text-align: justify;
        line-height: 1.6; /* opcional, para que se vea más legible */
    }
</style>